/*
Akhila 01/05/2023 3075154998 PrePopulated static preprocessor data In Ui
Sohel 01/17/2023 2698964415 payload Changes
Ravi 01/30/2023 2698964415 Fixed lebel condition issue
suresh peddavoora 02/27/2023 2698964415 textfields alignments fixes

*/
import React from 'react';
import GuiTable from '../../../../../../components/FormComponents/GuiTable';
import {tableIcons} from '../../../../../../components/TableIcons';
import {getDataManagerOptions as getOptions} from '../../../../../../components/SqlRuleBuilder/utils';

const ConditionTable = ({data}) => {
  const tableData =
    data?.length > 0 ?
      data.map((el, index) => {
        return {
          conditionCode: el.conditionCode,
          field2RepositoryName: `${el.field2RepositoryName}.${el.field2Name}`,
          compareValue:
              getOptions(el?.selectField?.dataType?.toLowerCase())?.filter(
                (e) => e.value === el?.compareValue,
              )[0]?.label,

          rhsFormulaExpression: el.rhsRuleExpression,
        };
      }) :
      [];

  const columns = [
    {
      title: 'Condition Code',
      field: 'conditionCode',
    },
    {
      title: 'Field',
      field: 'field2RepositoryName',
    },
    {
      title: 'Condition',
      field: 'compareValue',
    },
    {
      title: 'Value',
      field: 'rhsFormulaExpression',
    },
  ];
  return (
    <>
      <div className="custom-table  custom-toolbar-icons custom-actions-icon global-field-table new-standard-textfields">
        <GuiTable
          title={''}
          columns={columns}
          icons={tableIcons}
          data={tableData}
          options={{
            toolbarButtonAlignment: 'left',
            toolbar: false,
            search: false,
            emptyRowsWhenPaging: false,
            paging: false,
            headerStyle: {
              fontWeight: 'bold',
              fontSize: '0.938rem',
              padding: '16px',
            },
          }}
        />
      </div>
    </>
  );
};

export default ConditionTable;
